import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { BooleanCheckWidgetConfig } from './model';
import { resolveWidgetTextColor } from '../../helpers/widget-color.helper';

@Component({
  selector: 'app-boolean-check-widget',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule, TranslateModule],
  templateUrl: './boolean-check-widget.component.html',
  styleUrl: './boolean-check-widget.component.scss',
})
export class BooleanCheckWidgetComponent {
  @Input() value: boolean = false;
  @Input() tooltip?: string | ((value: boolean) => string);
  @Input() checkedColor?: string;
  @Input() uncheckedColor?: string;
  @Input() action?: (value: boolean) => void;
  @Input() translate: boolean = false; // Flag to enable i18n
  @Input() translationPrefix?: string; // Translation prefix from grid
  /**
   * Get the icon to display based on value
   */
  getIcon(): string {
    return this.value ? 'check_box' : 'check_box_outline_blank';
  }

  /**
   * Get the color based on value and configured colors
   */
  getColor(): string {
    const colorName = this.value ? this.checkedColor : this.uncheckedColor;

    return resolveWidgetTextColor({ color: colorName });
  }

  /**
   * Get the tooltip key for template
   * If tooltip is a function, call it with the boolean value
   * If translate=true with translationPrefix, build full translation key for both string and callback results
   * Otherwise return as-is
   */
  get tooltipKey(): string | null {
    if (!this.tooltip) return null;

    // If tooltip is a function, call it
    const tooltipValue =
      typeof this.tooltip === 'function'
        ? this.tooltip(this.value)
        : this.tooltip;

    // If translate is enabled and we have a prefix, build full translation key
    if (this.translate && this.translationPrefix) {
      return `${this.translationPrefix}.${tooltipValue}`;
    }

    return tooltipValue;
  }

  /**
   * Handle click event
   */
  onClick(event: MouseEvent): void {
    event.stopPropagation();
    if (this.action) {
      this.action(this.value);
    }
  }
}
